import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAbp3XMJARhPOAHZ06cesEjXDbI7YuvAWQ",
  authDomain: "redotoeic.firebaseapp.com",
  projectId: "redotoeic",
  storageBucket: "redotoeic.firebasestorage.app",
  messagingSenderId: "477375505620",
  appId: "1:477375505620:web:c9fd81601349dfe2e18741",
  measurementId: "G-NMM0DC365T",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
